import { ArrowDownRight, ArrowUpRight } from "lucide-react";

const TONES = {
  primary: {
    iconBg: "bg-primary/[0.06]",
    iconColor: "text-primary",
    accent: "bg-primary",
    bar: "bg-primary",
  },
  collect: {
    iconBg: "bg-collect/[0.08]",
    iconColor: "text-collect",
    accent: "bg-collect",
    bar: "bg-collect",
  },
  emerald: {
    iconBg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    accent: "bg-emerald-500",
    bar: "bg-emerald-500",
  },
  accent: {
    iconBg: "bg-accent/15",
    iconColor: "text-accent-dark",
    accent: "bg-accent",
    bar: "bg-accent",
  },
  amber: {
    iconBg: "bg-amber-50",
    iconColor: "text-amber-600",
    accent: "bg-amber-500",
    bar: "bg-amber-500",
  },
  red: {
    iconBg: "bg-red-50",
    iconColor: "text-red-600",
    accent: "bg-red-500",
    bar: "bg-red-500",
  },
};

export default function StatCard({
  label,
  value,
  sub,
  icon: Icon,
  tone = "primary",
  delta,
  up,
  progress,
  valueClassName = "",
}) {
  const style = TONES[tone] ?? TONES.primary;

  return (
    <div className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-primary/[0.07] bg-white p-3 shadow-[0_1px_2px_rgba(127,29,29,0.04)] transition-all hover:border-primary/10 hover:shadow-[0_2px_8px_rgba(127,29,29,0.07)]">
      <div className={`absolute inset-y-0 left-0 w-[3px] ${style.accent}`} aria-hidden />

      <div className="flex flex-1 items-start gap-2.5 pl-1">
        {Icon && (
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${style.iconBg} ${style.iconColor} ring-1 ring-black/[0.03]`}
          >
            <Icon className="h-4 w-4" strokeWidth={2.25} />
          </span>
        )}

        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-start justify-between gap-2">
            <p className="truncate text-[10px] font-semibold uppercase tracking-[0.06em] text-primary/45">
              {label}
            </p>
            {delta != null && (
              <span
                className={`inline-flex shrink-0 items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[9px] font-bold ${
                  up ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600"
                }`}
              >
                {up ? <ArrowUpRight className="h-2.5 w-2.5" /> : <ArrowDownRight className="h-2.5 w-2.5" />}
                {delta}
              </span>
            )}
          </div>

          <p
            className={`mt-0.5 truncate text-base font-bold leading-tight tracking-tight text-primary sm:text-lg ${valueClassName}`}
          >
            {value}
          </p>

          <div className="mt-0.5 min-h-[14px]">
            {sub && (
              <p className="truncate text-[10px] leading-snug text-primary/40" title={sub}>
                {sub}
              </p>
            )}
          </div>

          <div className="mt-2 min-h-1">
            {progress != null ? (
              <div className="h-1 overflow-hidden rounded-full bg-primary/[0.06]">
                <div
                  className={`h-full rounded-full ${style.bar} transition-all duration-700`}
                  style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                />
              </div>
            ) : (
              <div className="h-1" aria-hidden />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
